import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',
    bgVideo: searchParams.get('bgVideo') || '1',
    bgPoster: searchParams.get('bgPoster') || null,
    phoneNumber,
    title: getDefaultValue(
      searchParams.get('title'),
      'присылайте номер варианта',
    ),
    socials: searchParams.get('socials'),
    qrTitle1: searchParams.get('qrTitle1'),
    qrCode1: searchParams.get('qrCode1'),
    qrTitle2: searchParams.get('qrTitle2'),
    qrCode2: searchParams.get('qrCode2'),
    startFrom: parseInt(searchParams.get('startFrom') || '') || 1,
    advtImage: searchParams.get('advtImage') || null,
    advtImageSize: searchParams.get('advtImageSize') || '30',
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 10000,
    carousel: searchParams.get('carousel') || '0',
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 10,

    phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '5',
    titleFontSize: searchParams.get('titleFontSize') || '5',

    sizeQR: searchParams.get('sizeQR') || '27.6',
    paddingQR: searchParams.get('paddingQR') || '0',

    questionFontSize: searchParams.get('questionFontSize') || '5',
    answerFontSize: searchParams.get('answerFontSize') || '5',
    varNumFontSize: searchParams.get('varNumFontSize') || '5.5',

    winnerFontSize: searchParams.get('winnerFontSize') || '5.21',
  };
};
